module.exports = __webpack_public_path__ + "img/Bunny.2d00d1cc.jpeg";